"use client";
// src/components/iraq/IraqClientWrapper.jsx
import dynamic from "next/dynamic";

const IraqClient = dynamic(
  () => import("@/components/iraq/IraqClient"),
  { ssr: false }
);

export default function IraqClientWrapper({ initialContent }) {
  return <IraqClient initialContent={initialContent} />;
}